module.exports = __webpack_public_path__ + "img/event-ic-lucky-tips.b98b4c63.png";